export enum LayoutStyleType {
  Xs = 'Xs',
  Sm = 'Sm',
  Md = 'Md',
  Lg = 'Lg',
  Xl = 'Xl',
  Xxl = 'Xxl',
}
